import {
  ApiListRequest,
  ApiListResponse,
  ProductCategoryDTO,
  ProductDTO,
  ProductOrderDetailDTO,
  ProductOrderSummaryDTO,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["memberApiProduct"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  listCategories: (filter: unknown) =>
    [...keys.all(), "listCategories", filter] as QueryKey,
  summary: (params: unknown) => [...keys.all(), "summary", params] as QueryKey,
};

export const memberApiProduct = {
  keys,
  queries: {
    summary: (params: {
      productOrderList: ProductOrderDetailDTO[];
      promotionCode?: string;
    }) => {
      return {
        queryKey: keys.summary(params),
        queryFn: async () => {
          return (
            await api.post<ProductOrderSummaryDTO>(
              `/customer/product/order/summary`,
              params,
            )
          ).data;
        },
      };
    },
  },
  infiniteQueries: {
    list: (
      params: {
        productCategoriesIncluded?: number[];
        allowAppPurchases?: boolean;
        allowWebPurchases?: boolean;
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.put<ApiListResponse<ProductDTO>>(
              `/customer/product/available/search`,
              { ...params, page: pageParam },
            )
          ).data;
        },
        ...numberPagination,
      }),
    listCategories: (params: ApiListRequest) =>
      infiniteQueryOptions({
        queryKey: keys.listCategories(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.put<ApiListResponse<ProductCategoryDTO>>(
              `/customer/product/category/search`,
              {
                ...params,
                page: pageParam,
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
